// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"a050eade","321":"0d4ff12e","595":"e7b55267","664":"8417ea0d","742":"0124d3cc","865":"a75fc886","988":"323e82fd"}[chunkId] + ".chunk.js";
};